export const convertServerDateToLocalDate = (serverDate: string) => {
    const localDate = new Date(serverDate);
    const customDate = localDate.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    const customTime = localDate.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    return { customDate, customTime };
}